import { createSvgIcon } from '@mui/material/utils';

export const BrokenImage = createSvgIcon(
  <svg
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.5 2.16667V7.65833L13 5.15L9.66667 8.49167L6.33333 5.15833L3 8.49167L0.5 5.98333V2.16667C0.5 1.25 1.25 0.5 2.16667 0.5H13.8333C14.75 0.5 15.5 1.25 15.5 2.16667ZM13 7.51667L15.5 10.025V13.8333C15.5 14.75 14.75 15.5 13.8333 15.5H2.16667C1.25 15.5 0.5 14.75 0.5 13.8333V8.35L3 10.8417L6.33333 7.50833L9.66667 10.8417L13 7.51667Z" fill="#6B7280" />
  </svg>,
  'BrokenImage');
